const ROLES = {
    SUPER_ADMIN: 'super_admin',
    TECHNICAL_ADMIN: 'technical_admin',
    GARDEN_TESTER: 'garden_tester',
    REGIONAL_MANAGER: 'regional_manager',
    FIELD_MANAGER: 'field_manager',
    PRO_USER: 'pro_user',
    END_USER: 'end_user',
    DEMO: 'demo',
};

const ROLE_LABELS = {
    super_admin: 'Super Admin',
    technical_admin: 'Technical Admin',
    regional_manager: 'Regional Manager',
    field_manager: 'Field Manager',
    pro_user: 'Pro User',
    end_user: 'End User',
    demo: 'Demo'
};

const ACCESS_LEVEL = {
    'super_admin': 0,
    'technical_admin': 1,
    'regional_manager': 2,
    'field_manager': 3,
    'end_user': 5,
    'demo': 5,
    'garden_tester': 6
};

const hasAccess = (intendedRole, currentRole) => {
    if (!currentRole) return false;

    return ACCESS_LEVEL[currentRole] <= ACCESS_LEVEL[intendedRole]
}

const hasRoles = (intendedRoles, currentRole) => {
    if (!currentRole || !intendedRoles) return false;

    return Array.isArray(intendedRoles) ? intendedRoles.includes(currentRole) : false;
}

export {
    ROLES,
    ROLE_LABELS,
    hasAccess,
    hasRoles
}